import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCHA3gZRD-1d31ID5u2jugkEvqzBBlp3po',
  authDomain: 'woundsolutionsprod.firebaseapp.com',
  projectId: 'woundsolutionsprod',
};


firebase.initializeApp(firebaseConfig);

export default firebase;